import { useTranslation } from "react-i18next";
import { FaWhatsapp } from "react-icons/fa6";

interface IProps {
  bottomNumber?: string;
}

function WhatsAppIcon(props: IProps) {
  const { t, i18n } = useTranslation();
  return (
    <div
      dir={`${i18n.language === "ar" ? "rtl" : "ltr"}`}
      className={`fixed flex items-center bg-gray-50 mobile:bg-white bottom-3 mobile:bottom-${props.bottomNumber} rounded-lg z-50 w-[224px] mobile:w-[151px] h-[41px]  mb-48 mobile:mb-20 pb-2 pt-2 cursor-pointer ${
        i18n.language === "ar"
          ? "left-0 mobile:ml-4 ml-11"
          : "right-0 mobile:mr-4 mr-11"
      }`}
    >
      <FaWhatsapp
        className={`${
          i18n.language === "ar" ? "mr-[18px]" : "ml-[18px]"
        }  text-green-500 text-xl`}
      />
      <p
        className={`font-ar text-sm text-[#435363] ${
          i18n.language === "ar" ? "mr-2" : "ml-2"
        } `}
      >
        {t("app.shared.helpCenter")}
      </p>
    </div>
  );
}

export default WhatsAppIcon;
